import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { ConfigProvider } from 'antd';

ConfigProvider.config({
    theme: {
        primaryColor: '#25b864',
    },
});

ReactDOM.render(
    <ConfigProvider>
        <App />
     </ConfigProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
